/**
 * BRAND CONFIGURATION — Single Source of Truth (STELLAR / UAE)
 * ============================================================
 * STELLAR = a UAE convenience-store chain located inside petrol stations —
 * fuel, coffee, snacks, groceries, car wash, cigarettes, cold drinks.
 * Not a fashion brand — please keep all copy in the forecourt / convenience
 * store / motorist context.
 *
 * To rebrand:
 *   1. Edit values below.
 *   2. Edit --kazo-* CSS variables in frontend/src/index.css (keep names, swap hex).
 *   3. Edit <title> + <meta> in frontend/public/index.html.
 *   4. Edit BRAND_NAME + super/brand admin emails in backend/.env.
 *   5. Replace hero imagery below (or upload via Public Site CMS).
 *
 * DO NOT rename CSS class names (kazo-text-burgundy etc.) — those are stable
 * selectors used across 50+ components. Only the CSS variable VALUES change.
 */

export const BRAND = {
  // -- Identity --------------------------------------------------------
  name: "STELLAR",
  legalName: "Stellar Retail LLC",
  domain: "stellar.ae",
  shortDescriptor: "UAE petrol-forecourt convenience stores",

  // -- Platform identity (Fundle = the loyalty engine running this app) --
  platform: "Fundle",
  poweredBy: "Powered by Fundle",
  aiAssistant: "Fundle Brain",
  platformLogoUrl: "/fundle-logo.png",

  // -- Loyalty programme branding -------------------------------------
  loyaltyProgramName: "Stellar Rewards",
  welcomePointsValue: 100,
  welcomeToast: "Welcome to Stellar Rewards! 100 bonus points credited to your fuel wallet.",
  ctaJoinFree: "Join Stellar Rewards Free",

  // -- Social ---------------------------------------------------------
  social: {
    instagram: "https://instagram.com/stellar_ae",
    facebook: "https://facebook.com",
    youtube: "https://youtube.com",
  },

  // -- SEO / meta (mirror in frontend/public/index.html) ---------------
  meta: {
    title: "Stellar Rewards — Fuel, coffee & convenience across the UAE. Powered by Fundle.",
    description:
      "Join the official Stellar loyalty programme at UAE petrol forecourts. Earn points in AED on every fuel top-up, coffee, snack, car wash and grocery run — redeem across every Stellar store from Dubai to Fujairah. Powered by Fundle.",
  },

  // -- Public home copy (CMS overrides take precedence at runtime) -----
  homeCopy: {
    heroEyebrow: "STELLAR REWARDS · UAE FORECOURT LOYALTY · POWERED BY FUNDLE",
    heroHeadline1: "Fill up.",
    heroHeadlineEm: "Earn",
    heroHeadline2: "back.",
    heroSubtext:
      "The official Stellar loyalty programme for UAE motorists. Every litre of fuel, every coffee, every convenience run earns points in AED — redeemable across every Stellar forecourt from Abu Dhabi to Ras Al Khaimah.",
    heroImageAlt: "Stellar UAE petrol forecourt at night",
    boutiqueImageAlt: "Stellar convenience store interior at a Dubai petrol station",
    editorialImageAlt: "Motorist scanning Stellar loyalty QR at the pump",
  },

  // -- Footer copy ----------------------------------------------------
  footerTagline:
    "The official loyalty programme for Stellar UAE forecourts — where every litre, coffee and car wash earns you more.",

  // -- Login / portal copy --------------------------------------------
  loginCopy: {
    descriptor:
      "A unified suite for loyalty, forecourt operations, CRM and campaigns — purpose-built for Stellar UAE petrol-station convenience stores.",
    imageAlt: "STELLAR forecourt",
    heroTitleTop: "Command",
    heroTitleEm: "your forecourt.",
  },

  // -- Locale (UAE) ---------------------------------------------------
  locale: {
    code: "en-AE",
    timezone: "Asia/Dubai",
    currency: "AED",
    currencySymbol: "AED",
    dateFormat: "DD/MM/YYYY",
    mobileFormat: "+9715XXXXXXXX",
    taxLabel: "VAT",
  },

  // -- Convenience-store categories (used in seed data + AI prompts) ---
  categories: [
    "Fuel", "Coffee", "Snacks", "Beverages", "Cold Drinks",
    "Groceries", "Car Wash", "Automotive", "Cigarettes",
    "Ice Cream", "Bakery", "Water", "Sandwiches",
  ],

  // -- Brand colour palette (Midnight + Champagne Gold) ---------------
  colors: {
    black: "#05070E",
    cream: "#F7F3EA",
    burgundy: "#0F1626",
    burgundyDeep: "#070B14",
    champagne: "#C7A254",
    champagneLight: "#E8D191",
  },
};

export default BRAND;
